export default __webpack_public_path__ + "static/media/dogs1.892c14a8.jpg";